<script>
import { mapGetters } from "vuex";
import { menuItems } from "./menu";

export default {
  data() {
    return {
      menuItems: [],
    };
  },

  computed: {
    ...mapGetters("auth", ["MyUserPerm"]),
    ...mapGetters("setting", ["GeneralSettings"]),
  },

  created() {
    const checkActive = (items) => {
      return items.map(item => {
        if (item.subItems) {
          item.subItems = checkActive(item.subItems);
          item.open = item.subItems.some(
            sub => sub.open || this.$route.path === sub.link
          );
        } else {
          item.open = this.$route.path === item.link;
        }
        return item;
      });
    };

    this.menuItems = checkActive(menuItems);
  },

  methods: {
    hasItems(item) {
      return item.subItems && item.subItems.length > 0;
    },

    toggle(item) {
      this.$set(item, "open", !item.open);
    },

    isActive(link) {
      return link && this.$route.path === link;
    },

    isSubActive(item) {
      return (
        item.subItems &&
        item.subItems.some(
          sub =>
            sub.link === this.$route.path ||
            (sub.subItems &&
              sub.subItems.some(child => child.link === this.$route.path))
        )
      );
    },

    canShow(item) {
      return (
        (!item.actionpage ||
          (this.BranchData && this.BranchData.BranchId != 0)) &&
        (!item.perm || this.MyUserPerm[item.perm] == 1) &&
        (!item.set || this.GeneralSettings[item.set] == 1)
      );
    },

    filteredSubItems(items) {
      return items.filter(i => this.canShow(i));
    }
  }
};
</script>

<template>
  <div class="sidebar-v2">
    <div class="sidebar-content">
      <ul class="menu-v2">

        <template v-for="item in menuItems">

          <!-- SECTION TITLE -->
          <li v-if="item.isTitle && (!item.actionpage || (BranchData && BranchData.BranchId != 0))"
            :key="'title-' + item.id" class="menu-section">
            {{ $t(item.label) }}
          </li>

          <!-- MAIN ITEM -->
          <li v-else-if="!item.isLayout && canShow(item)" :key="'item-' + item.id">

            <!-- LEVEL 1 -->
            <div v-if="hasItems(item)" class="menu-group">

              <div class="menu-item-v2 has-children" :class="{ active: isSubActive(item) }" @click="toggle(item)">
                <div class="icon-box">
                  <i :class="`bx ${item.icon}`"></i>
                </div>
                <span>{{ $t(item.label) }}</span>
                <i class="bx bx-chevron-down arrow" :class="{ open: item.open }"></i>
              </div>

              <transition name="fade">
                <ul v-show="item.open" class="submenu-v2">

                  <!-- LEVEL 2 -->
                  <li v-for="(subitem, index) in filteredSubItems(item.subItems)" :key="'sub-' + (subitem.id || index)">

                    <!-- HAS CHILDREN -->
                    <div v-if="hasItems(subitem)" class="submenu-group">

                      <div class="submenu-item has-children" @click="toggle(subitem)">
                        {{ $t(subitem.label) }}
                        <i class="bx bx-chevron-down arrow" :class="{ open: subitem.open }"></i>
                      </div>

                      <!-- LEVEL 3 -->
                      <ul v-show="subitem.open" class="submenu-v2 nested">

                        <li v-for="(child, i) in filteredSubItems(subitem.subItems)" :key="'child-' + (child.id || i)">
                          <router-link v-if="child.link" :to="child.link" class="submenu-item"
                            :class="{ active: isActive(child.link) }">
                            {{ $t(child.label) }}
                          </router-link>
                        </li>

                      </ul>
                    </div>

                    <!-- NORMAL LINK -->
                    <router-link v-else-if="subitem.link" :to="subitem.link" class="submenu-item"
                      :class="{ active: isActive(subitem.link) }">
                      {{ $t(subitem.label) }}
                    </router-link>

                    <!-- LABEL ONLY -->
                    <span v-else class="submenu-item">
                      {{ $t(subitem.label) }}
                    </span>

                  </li>

                </ul>
              </transition>

            </div>

            <!-- SINGLE LINK -->
            <router-link v-else-if="item.link" :to="item.link" class="menu-item-v2"
              :class="{ active: isActive(item.link) }">
              <div class="icon-box">
                <i :class="`bx ${item.icon}`"></i>
              </div>
              <span>{{ $t(item.label) }}</span>
            </router-link>

            <!-- FALLBACK -->
            <div v-else class="menu-item-v2">
              <div class="icon-box">
                <i :class="`bx ${item.icon}`"></i>
              </div>
              <span>{{ $t(item.label) }}</span>
            </div>

          </li>

        </template>

      </ul>
    </div>
  </div>
</template>